
export default {
  name: 'CardSection',
  props: {
    blok: {
      type: Object,
      required: true
    }
  }
}
